import { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import libForm from "../../../../util/libForm";

import reqTipoCliente from "../../../../services/reqMultiTenant/reqTipoCliente";

function SelectTipoCliente({ id, control }) {
	const [listClientTypes, setListClientTypes] = useState([]);

	const loadClientTypes = async () => {
		try {
			const res = await reqTipoCliente.listAll();
			if (res && res.data) {
				setListClientTypes(res.data);
			} else if (Array.isArray(res)) {
				setListClientTypes(res);
			}
		} catch (error) {
			console.error("Erro ao buscar tipos de cliente", error);
		}
	};

	useEffect(() => {
		loadClientTypes();
	}, []);

	return (
		<div className="content-select">
			<div className="input-select-box d-flex flex-column col-6 col-sm-6 col-lg-3  min-w-52">
				<label htmlFor="tipo-cliente">Tipo de Cliente</label>
				<Controller
					name={id}
					control={control}
					defaultValue=""
					render={({ field }) => (
						<select {...field} onKeyDown={(e) => libForm.EnterTab(e)}>
							<option value="" disabled hidden>
								TODOS OS CLIENTES
							</option>
							<option value="">TODOS OS CLIENTES</option>
							{listClientTypes.map((type) => (
								<option key={type.id_tipocliente} value={type.id_tipocliente}>
									{type.nome}
								</option>
							))}
						</select>
					)}
				/>
			</div>
		</div>
	);
}

export default SelectTipoCliente;
